import React from 'react';

const UploadedImages = ({ uploadedImageUrls, largeImageUrls, removeFile }) => {
    return (
        <div className="flex flex-wrap fixed bottom-24 space-x-2 px-4">
            {Array.isArray(uploadedImageUrls) && uploadedImageUrls.length > 0 ? (
                uploadedImageUrls.map((url, index) => (
                    <div key={index} className="relative m-2">
                        <img src={url} alt={`Uploaded ${index}`} className="w-auto h-[60px] object-cover" />
                        <button
                            className="absolute top-1 right-1 bg-white bg-opacity-70 rounded-full text-sm p-1 cursor-pointer"
                            onClick={() => removeFile(url)}
                        >
                            &times;
                        </button>
                    </div>
                ))
            ) : null}

            {largeImageUrls.map((url, index) => (
                <div key={index} className="relative m-2 border-4 border-red-500">
                    <img src={url} alt={`Large ${index}`} className="w-auto h-[60px]"/>
                    <button
                        className="absolute top-1 right-1 bg-white bg-opacity-70 rounded-full text-sm h-5 w-5 p-1 cursor-pointer"
                        onClick={() => removeFile(url)}
                    >
                        &times;
                    </button>
                </div>
            ))}
        </div>
    );
};

export default UploadedImages;